import { EuiButtonEmpty, EuiFlexGroup, EuiFlexItem } from "@inscopix/ideas-eui";
import { IDetailCellRendererParams } from "ag-grid-community";
import { CallOutError } from "components/CallOutError/CallOutError";
import { useState } from "react";
import { DetailRendererAdvanced } from "./DetailRendererAdvanced";
import { DetailRendererBase } from "./DetailRendererBase";
import { ParamsEditorRowDatum } from "components/ToolEditor/ToolEditor.types";

export const ADVANCED_PARAM_DETAIL_HEIGHT = 300;
export const ParameterViewerDetailRenderer = ({
  data,
  node,
  api,
}: IDetailCellRendererParams<ParamsEditorRowDatum>) => {
  const [isAdvanced, setIsAdvanced] = useState(false);

  const [normalHeight, setNormalHeight] = useState<number | null | undefined>();

  if (data === undefined) {
    return <CallOutError />;
  }

  if (isAdvanced) {
    return (
      <DetailRendererAdvanced
        data={data}
        onClose={() => {
          setIsAdvanced(false);
          node.setRowHeight(normalHeight);
          api.onRowHeightChanged();
        }}
        editMode={false}
      />
    );
  }

  return (
    <EuiFlexGroup
      direction="column"
      style={{ padding: "15px 15px 5px 15px" }}
      gutterSize="none"
    >
      <EuiFlexItem grow={false}>
        <DetailRendererBase data={data} editMode={false} />
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiButtonEmpty
          size="xs"
          style={{ width: 150, alignSelf: "flex-end" }}
          onClick={() => {
            setIsAdvanced(true);
            setNormalHeight(node.rowHeight);
            node.setRowHeight(ADVANCED_PARAM_DETAIL_HEIGHT);
            api.onRowHeightChanged();
          }}
        >
          Advanced mode
        </EuiButtonEmpty>
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
